const PRIMARY = "#C8A96E";

export type PortalMediaPackage = {
  id: string;
  job_id?: string | null;
  package_type: string;
  title: string;
  cover_url: string | null;
  video_url: string | null;
  download_url: string | null;
  public_token: string;
  is_published?: boolean;
};

const MEDIA_TYPE_INFO: Record<string, { label: string; icon: string; color: string }> = {
  online_dvd:  { label: "Online DVD",    icon: "ri-disc-line",        color: "#C8A96E" },
  usb:         { label: "USB Package",   icon: "ri-usb-line",         color: "#f59e0b" },
  embed:       { label: "Embed Player",  icon: "ri-play-circle-line", color: "#0ea5e9" },
  cover_frame: { label: "Cover / Frame", icon: "ri-image-edit-line",  color: "#34d399" },
  combo:       { label: "Combo Pack",    icon: "ri-gift-2-line",      color: "#C8A96E" },
};

interface Props {
  mediaPackages: PortalMediaPackage[];
  brandColor?: string;
}

export default function MediaPackagesSection({ mediaPackages, brandColor = PRIMARY }: Props) {
  return (
    <div>
      <h2 className="text-[#0f172a] font-semibold text-base mb-4 flex items-center gap-2">
        <span className="w-5 h-5 flex items-center justify-center" style={{ color: brandColor }}>
          <i className="ri-disc-line"></i>
        </span>
        Media Packages
      </h2>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        {mediaPackages.map((mp) => {
          const info =
            MEDIA_TYPE_INFO[mp.package_type] ?? {
              label: mp.package_type,
              icon: "ri-disc-line",
              color: PRIMARY,
            };
          return (
            <div
              key={mp.id}
              className="bg-white rounded-xl border border-slate-200 overflow-hidden flex flex-col"
            >
              <div className="h-28 w-full bg-slate-50 overflow-hidden relative flex items-center justify-center">
                {mp.cover_url ? (
                  <>
                    <img
                      src={mp.cover_url}
                      alt={mp.title}
                      className="w-full h-full object-cover object-top opacity-70"
                      onError={(e) => {
                        (e.target as HTMLImageElement).style.display = "none";
                      }}
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-white to-transparent" />
                  </>
                ) : (
                  <div
                    className="w-14 h-14 rounded-full flex items-center justify-center"
                    style={{ backgroundColor: info.color + "15" }}
                  >
                    <i className={`${info.icon} text-3xl`} style={{ color: info.color }}></i>
                  </div>
                )}
                <div className="absolute top-2 left-2">
                  <span
                    className="text-[10px] px-2 py-0.5 rounded-full font-medium"
                    style={{ backgroundColor: info.color + "15", color: info.color }}
                  >
                    {info.label}
                  </span>
                </div>
              </div>

              <div className="p-4 flex-1 flex flex-col gap-3">
                <p className="text-[#0f172a] font-semibold text-sm">{mp.title}</p>
                <a
                  href={`/media/${mp.public_token}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-auto flex items-center justify-center gap-2 text-white text-xs font-semibold py-2.5 rounded-xl transition-colors cursor-pointer whitespace-nowrap"
                  style={{ backgroundColor: brandColor, color: "#000" }}
                >
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-external-link-line"></i>
                  </span>
                  Open Package
                </a>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}